import { render } from "./LogoutButton.vue?vue&type=template&id=6a13dbb6"
import script from "./LogoutButton.vue?vue&type=script&lang=js"
export * from "./LogoutButton.vue?vue&type=script&lang=js"
script.render = render

export default script